<template>
  <div class="box">
    <div class="lbox" :class="info.icon"></div>
    <div class="rbox">
      <div class="l">{{ info.key }}</div>
      <div class="r" :class="info.color">{{ info.val }}</div>
      <div class="after1"></div>
      <div class="after2"></div>
      <div class="after3"></div>
      <div class="after4"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
$height: 0.15rem;

.box {
  position: relative;
  overflow: initial;
  height: 0.15rem;
}
.lbox {
  position: absolute;
  width: 2 * $height;
  height: 2 * $height;
  top: -0.5 * $height;
  left: -0.06rem;
  margin-left: 0;
  float: left;
  color: #0f69ca;
  line-height: 2 * $height;
  text-align: center;
  font-size: 0.5 * $height;
  background: url(../img/ticonbg.png);
  background-size: 75% 75%;
  background-position: 42% 74%;
  background-repeat: no-repeat;
}
.pcs1::after{
  content: " ";
  display: block;
  position: absolute;
  width: 24%;
  height: 24%;
  left: 39%;
  top: 40%;
  background: url(../img/pcs1.png);
  background-size: 100% 100%;
}
.pcs2::after{
  content: " ";
  display: block;
  position: absolute;
  width: 24%;
  height: 24%;
  left: 39%;
  top: 40%;
  background: url(../img/pcs2.png);
  background-size: 100% 100%;
}
.pcs3::after{
  content: " ";
  display: block;
  position: absolute;
  width: 24%;
  height: 24%;
  left: 39%;
  top: 40%;
  background: url(../img/pcs3.png);
  background-size: 100% 100%;
}
.rbox {
  position: relative;
  width: 1.36rem;
  float: right;
  height: $height;
  line-height: $height;
  font-size: 0.05rem;
  color: #0f69ca;
}
.l {
  height: $height;
  display: inline;
  position: relative;
  float: left;
  font-size: 0.05rem;
}
.l::after {
  content: " ";
  display: block;
  position: absolute;
  left: 110%;
  top: 0.06rem;
  width: 0.1025rem;
  height: 0.04rem;
  background: url(../img/tafter.png);
  background-size: 100% 100%;
}
.r {
  height: $height;
  font-weight: 700;
  font-size: 0.07rem;
  width: 49%;
  float: right;
  text-align: right;
}
.red {
  color: #fb7a8e;
}
.green {
  color: #37baca
}
.after1 {
  position: absolute;
  height: 0.01rem;
  left: 0rem;
  width: 0.03rem;
  bottom: 0rem;
  background: #0f69ca;
}
.after2 {
  position: absolute;
  height: 0.005rem;
  left: 0.04rem;
  width: 0.06rem;
  bottom: 0rem;
  background: #0f69ca;
}
.after3 {
  position: absolute;
  height: 1px;
  left: 0.12rem;
  right: 0;
  bottom: 0rem;
  background: rgba($color: #0f69ca, $alpha: 0.12);
}
.after4 {
  position: absolute;
  height: 0.005rem;
  width: 0.05rem;
  right: 0;
  bottom: 0rem;
  background: #0f69ca;
}
</style>


// WEBPACK FOOTER //
// src/components/webgl/ui/valstatus/icon.vue